import { render, staticRenderFns } from "./SvgClose.vue?vue&type=template&id=7c536152&"
import script from "./SvgClose.vue?vue&type=script&lang=js&"
export * from "./SvgClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports